import { THubspotFormSpecification } from '@utils/form/hubspot/schema'
import { TProductDetailSections } from '../../useProductPageVariation'
import { ProductPlusForm } from './plusForm'
import { IProductEntry } from 'app/_services/CMS/contentful/types/productEntry'
import { useUnavailableProductDetailSection } from '../useUnavailableProductDetailSection'

export function usePlusProductDetailSection({
  hubspotPlusForm,
  productData,
}: {
  hubspotPlusForm: THubspotFormSpecification
  productData: IProductEntry
}): TProductDetailSections {
  const priceSection = null

  return {
    priceSection,
    mainSection: hubspotPlusForm ? (
      <ProductPlusForm
        hubspotPlusForm={hubspotPlusForm}
        productData={productData}
      />
    ) : (
      useUnavailableProductDetailSection()?.mainSection
    ),
  }
}
